(function() {
      // Get current time in Denmark (CET/CEST)
      var now = new Date();
      var denmarkTime = new Intl.DateTimeFormat("en-US", { 
          timeZone: "Europe/Copenhagen", 
          hour: "2-digit", 
          hour12: false, 
          weekday: "short" 
      }).formatToParts(now);

      // console.log(denmarkTime);

      var hours = parseInt(denmarkTime.find(part => part.type === "hour").value, 10); // Denmark's hour (0-23)
      var dayName = denmarkTime.find(part => part.type === "weekday").value; // Day name (e.g., "Mon", "Sat")

      var isWeekend = (dayName === "Sat" || dayName === "Sun"); // True if Saturday or Sunday
      var isWorkHours = (hours >= 9 && hours < 17); // 9:00 AM - 5:00 PM Denmark time (Weekdays only)

      if (!isWeekend && isWorkHours) {
          //Load Zendesk Widget (Only on weekdays from 9:00 AM - 5:00 PM in Denmark time)
          var zendeskScript = document.createElement("script");
          zendeskScript.id = "ze-snippet";
          zendeskScript.src = "https://cdn.herodesk.io/livechat.js?wid=1eff7e3b4946bc";
          document.head.appendChild(zendeskScript);
      } else {
          //Load UserLink Widget (Full day on weekends OR outside work hours on weekdays in Denmark time)
          var userlinkScript = document.createElement("script");
          userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
          userlinkScript.charset = "utf-8";
          userlinkScript.id = "bai-scr-emb";
          userlinkScript.setAttribute("data-cid", "6842c60d40eca007446e2ceb");
          userlinkScript.setAttribute("async", "");
          userlinkScript.setAttribute("domain", "thenap.nl");
          document.head.appendChild(userlinkScript);
      }
          // var userlinkScript = document.createElement("script");
          // userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
          // userlinkScript.charset = "utf-8";
          // userlinkScript.id = "bai-scr-emb";
          // userlinkScript.setAttribute("data-cid", "6842c60d40eca007446e2ceb");
          // userlinkScript.setAttribute("async", "");
          // userlinkScript.setAttribute("domain", "thenap.nl");
          // document.head.appendChild(userlinkScript);
  })();

jQuery( document ).ready(function() {

  // Pre Order Text New option
  function getPreText(variantId) {
    return preTextData[String(variantId)] || null;
  }
  
    // Product Page quantity Block  
    if(jQuery('#productquantity').length){


      jQuery('#productquantity').on("click",".qty-quick .select-menu .options li", function () {

          const $thisMenu = jQuery(this).closest(".select-menu");
          const selectedText = jQuery(this).html();
              $thisMenu.find('.options li').removeClass("active");
              $thisMenu.find(".sBtn-text").html(selectedText);
              $thisMenu.removeClass("active").removeClass("red-new-btn");
              jQuery(this).addClass('active');

              const main_wrapper = jQuery(this).closest('.select-menu-main');
              const product = JSON.parse(jQuery('#productquantity').attr('data-product-json'));

              
              const selectedOptions = {};

              // Get selected size
              const selectedSize = jQuery(this).attr('data-option');

              // console.log(selectedSize);

              if (jQuery(this).closest('.select-menu').hasClass('other-option')) {
                  // Get allowed colors for selected size from variant list
                  const allowedColors = product.variants
                      .filter(v => v.option1 === selectedSize)
                      .map(v => v.option2);

                  // Loop through color options and show/hide based on allowedColors
                  const colorMenu = main_wrapper.find('.select-menu.color-option');

                  colorMenu.find('.options li').each(function () {
                      const $colorOption = jQuery(this);
                      const colorVal = $colorOption.attr('data-option');

                      if (allowedColors.includes(colorVal)) {
                          $colorOption.show();
                      } else {
                          $colorOption.hide();

                           // Check if the current active color is now invalid
                          const currentActiveColor = colorMenu.find('.options li.active').attr('data-option');

                          if (!allowedColors.includes(currentActiveColor)) {
                              // Remove current active
                              colorMenu.find('.options li').removeClass('active');

                              // Auto-select first allowed color
                              const firstAllowed = colorMenu.find('.options li').filter(function () {
                                  return allowedColors.includes(jQuery(this).attr('data-option'));
                              }).first();

                              if (firstAllowed.length) {
                                  firstAllowed.addClass('active');
                                  colorMenu.find('.sBtn-text').html(firstAllowed.html());
                                  selectedOptions['Vælg farve:'] = firstAllowed[0].attributes[0].nodeValue;
                              } 
                          }

                      }
                  });
              }
              
              
              const $thisMenu_new = jQuery(this).closest(".quantity-input");

              qty_option_get($thisMenu_new);
            
              // var main_sale_price = Shopify.formatMoney(matchedVariant.price, '{{amount_no_decimals}} kr');
              // main_wrapper.find('.f-price__sale .f-price-item--sale').text(main_sale_price);
              // main_wrapper.find('.f-price__regular .f-price-item--regular').text(main_sale_price);
            
              // if(matchedVariant.compare_at_price != null){
              //   var main_compare_price = Shopify.formatMoney(matchedVariant.compare_at_price, '{{amount_no_decimals}} kr');
              //   main_wrapper.find('.f-price__sale .f-price-item--regular s').text(main_compare_price);
              // }else{
              //   main_wrapper.find('.f-price__sale .f-price-item--regular s').text('');
              // }

              // if(matchedVariant.featured_image != null){
              //    main_wrapper.find('.product-card__image-wrapper img').attr('src',matchedVariant.featured_image.src);
              //    main_wrapper.find('.product-card__image-wrapper img').attr('srcset',matchedVariant.featured_image.src);
              // } 

        });


      function qty_option_get($get_curr){
          
        const product = JSON.parse(jQuery('#productquantity').attr('data-product-json'));
        $get_curr.attr('data-base-price', '0');
        const variantCount = {};
        const variantAvailable = {};


        $get_curr.find('.select-menu-main').each(function () {
          const selectedOptions = {};
          const selectedOptionsID = {};

          jQuery(this).find('.select-menu li.active').each(function () {
              const $option = jQuery(this);
              const optionName = $option.closest('.select-menu').attr('data-option-name');
              const optionValue = $option.attr('data-option');
              // const optionID = $option.attr('data-option-id');
              // console.log(optionID);
              selectedOptions[optionName] = optionValue;
              // selectedOptionsID[optionName] = optionID;
          });

          // Find matching variant
          const matchedVariant = product.variants.find(variant => {
              return variant.options.every((val, idx) => {
                  const optionName = product.options[idx];
                  return selectedOptions[optionName] === val;
              });
          });



          // console.log(selectedOptionsID);
          // sendVariantRequest(selectedOptionsID);
          // console.log(matchedVariant);

          if (matchedVariant) {
			  if (!matchedVariant.available) {
			    jQuery(this).closest('.product-quick-option').find('.option-message').text('Udsolgt');
			  } else{
			  	jQuery(this).closest('.product-quick-option').find('.option-message').text('');
			  }

        // if(matchedVariant.id == 56284255781251 && matchedVariant.available){
        //   jQuery(this).closest('.product-quick-option').find('.option-message').text('Vooruitbestelling');
        // }

        // if(matchedVariant.id == 56284255846787 && matchedVariant.available){
        //   jQuery(this).closest('.product-quick-option').find('.option-message').text('Vooruitbestelling');
        // }

        //  if(matchedVariant.id == 57633446789507 && matchedVariant.available){
        //   jQuery(this).closest('.product-quick-option').find('.option-message').text('Vooruitbestelling');
        // }

        //  if(matchedVariant.id == 57633446822275 && matchedVariant.available){
        //   jQuery(this).closest('.product-quick-option').find('.option-message').text('Vooruitbestelling');
        // }

        //  if(matchedVariant.id == 56284255814019 && matchedVariant.available){
        //   jQuery(this).closest('.product-quick-option').find('.option-message').text('Vooruitbestelling');
        // }

        const pre_option_data = getPreText(matchedVariant.id);
        if(pre_option_data){
          jQuery(this).closest('.product-quick-option').find('.option-message').text(pre_option_data.option_message);
        }

			} 

          // media change as per option color
          const mediaGallery = document.querySelector('media-gallery');
          if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
            mediaGallery.setActiveMedia(matchedVariant);
          }

          if (matchedVariant) {
              const variantId = matchedVariant.id;
              var get_main_pirce = $get_curr.attr('data-base-price');
              var new_pirce_main = parseInt(get_main_pirce) + parseInt(matchedVariant.price);
              $get_curr.attr('data-base-price', new_pirce_main);
              $get_curr.attr('data-compare-price', matchedVariant.compare_at_price);
              variantCount[variantId] = (variantCount[variantId] || 0) + 1;
              variantAvailable[variantId] = matchedVariant.available;
          }

          // console.log(matchedVariant);
          // console.log(variantCount);
          
      });

      var total_qty_select = $get_curr.find('input[name="quantitychange"]').val();
      var get_MainPirce = $get_curr.attr('data-base-price');
      var get_compare_at_price = $get_curr.attr('data-compare-price');
      var new_moneyFormat = '€{{amount_no_decimals_with_comma_separator}}';
      // console.log(FoxTheme.settings.moneyFormat);
      // console.log(get_MainPirce);

      if(total_qty_select == 2){
        var main_price_new = get_MainPirce / 100
        // var discountAmount = (main_price_new * 10) / 100;
        if(product.id == 15066644906371){
          var discountAmount = (main_price_new * 19.39) / 100;
        }else if(product.id == 15345107304835){
          var discountAmount = (main_price_new * 2.90) / 100;
        }else{
          var discountAmount = (main_price_new * 10) / 100;
        }
        var finalPrice = main_price_new - discountAmount;
        
        // console.log(discountAmount);
        // console.log(finalPrice);
        var discountedPrice = Math.floor(finalPrice * 100);
        $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(discountedPrice, new_moneyFormat));
      }else{
         $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
      }

      // if(product.id == 15345107304835){
      //   $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
      // }

      if($get_curr.hasClass('qty-option-2')){
        if(product.id == 15345107304835){
          $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
        }
      }else{
        $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_compare_at_price, new_moneyFormat));
      }

      // console.log("🧾 Variant Quantities:", variantCount);
      var totalCount = Object.keys(variantCount).length;   

      
      var qty_input_check = jQuery('.main-product .main-product-form input[name="quantity"]'); 

      var final_product_id = ""; 
      var final_product_qty = ""; 

    
      if(totalCount == 1){
        jQuery('#productquantity').removeClass('has-two-option').removeAttr('data-option-two-id');
        $.each(variantCount, function(id, count) {
                
          final_product_id = id; 
          final_product_qty = count; 

        });

      }else{
        jQuery('#productquantity').addClass('has-two-option');
        
        var two_i = 0;
        $.each(variantCount, function(id, count) {    
          // console.log(two_i);      

          if(two_i == 0){
            final_product_id = id; 
            final_product_qty = count; 
          }

          if(two_i == 1){
            jQuery('#productquantity').attr('data-option-two-id',id);
          }

          two_i++;

        });
      }

      if(qty_input_check.length == 0){
         jQuery( ".main-product .main-product-form" ).prepend('<input type="hidden" name="quantity" value="'+final_product_qty+'">');
      }else{
          qty_input_check.attr('value',final_product_qty);
      }

      jQuery( ".main-product .main-product-form input[name='id']" ).attr('value',final_product_id);
      jQuery( ".main-product .product__block.product__block--price input[name='id']" ).attr('value',final_product_id);

      // console.log(variantAvailable[final_product_id]);
      if (!variantAvailable[final_product_id]) {
	    // disable Add to Cart or show "Sold Out"
	    jQuery('.main-product .main-product-form .product-form__submit').attr('disabled','disabled');
	    jQuery('.main-product .main-product-form .product-form__submit span').text('Uitverkocht');
	    jQuery('.main-product .product-inventory-new .product__inventory').addClass('product__inventory--out-of-stock').removeClass('product__inventory--in-stock');
	    jQuery('.main-product .product-inventory-new .product__inventory-text').html('Uitverkocht.');

	  } else{

	  	jQuery('.main-product .main-product-form .product-form__submit').removeAttr('disabled');
	    jQuery('.main-product .main-product-form .product-form__submit span').text('IN WINKELWAGEN');
	    jQuery('.main-product .product-inventory-new .product__inventory').addClass('product__inventory--in-stock').removeClass('product__inventory--out-of-stock');
	    jQuery('.main-product .product-inventory-new .product__inventory-text').html('Op voorraad.<span class="black-text"> Levering binnen 2-4 werkdagen</span>');
	  }

      // if(final_product_id == 56284255781251 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Vooruitbestelling.<span class="black-text"> Verwacht verzenddatum: 15 mei.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('HIER VOORUITBESTELLEN');
      // }

      // if(final_product_id == 56284255846787 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Vooruitbestelling.<span class="black-text"> Verwacht verzenddatum: 8. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('HIER VOORUITBESTELLEN');
      // }

      // if(final_product_id == 57633446789507 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Vooruitbestelling.<span class="black-text"> Verwacht verzenddatum: 15. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('HIER VOORUITBESTELLEN');
      // }

      // if(final_product_id == 57633446822275 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Vooruitbestelling.<span class="black-text"> Verwacht verzenddatum: 17. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('HIER VOORUITBESTELLEN');
      // }

      // if(final_product_id == 56284255814019 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Vooruitbestelling.<span class="black-text"> Verwacht verzenddatum: 17. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('HIER VOORUITBESTELLEN');
      // }

      const pre_inventory_data = getPreText(final_product_id);
      if (pre_inventory_data) {
        jQuery('.main-product .product-inventory-new .product__inventory-text').html(`${pre_inventory_data.main_text}<span class="black-text">${pre_inventory_data.sub_text}</span>`);
        jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text(pre_inventory_data.button_text);
      }
    }



      jQuery('.product-template .main-product .product-form__buttons .product-form__submit').on('click',function(){

        if(jQuery('#productquantity').hasClass('has-option') && jQuery('#productquantity').hasClass('has-two-option')){

           var product_data_id = jQuery('#productquantity').attr('data-option-two-id');
            
            setTimeout(function() {
                    
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: product_data_id
                  },
                  dataType: 'json',
                  success: function () {
                    console.log('Product Added');
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true, detail: { open: false }
                    }));
                  },
                  error: function () {
                    
                  }
                });

            },1300);
        }
      })

      
      function qty_bundle_data(currn) {
         var product_quantity_check = jQuery(currn).find('input:checked').val();
          var product_id_check = jQuery(currn).find('input:checked').attr('data-product-id');
          var qty_input_check = jQuery('.main-product .main-product-form input[name="quantity"]');  
          // console.log(product_quantity_check);
          if(qty_input_check.length == 0){
             jQuery( ".main-product .main-product-form" ).prepend('<input type="hidden" name="quantity" value="'+product_quantity_check+'">');
          }else{
              qty_input_check.attr('value',product_quantity_check);
          }
          jQuery( ".main-product .main-product-form input[name='id']" ).attr('value',product_id_check);
      }
      
      jQuery(document).on('click','.quantity-main .quantity-input',function(e){
        var currn = jQuery(this);

        if(currn.closest('.quantity-main').hasClass('has-option')){
          qty_option_get(currn);
        }else{
          qty_bundle_data(currn);
        }

      });
      
      if(jQuery('.quantity-main').hasClass('has-option')){
          qty_option_get(jQuery('.quantity-input.active'));
        }else{
          qty_bundle_data(jQuery('.quantity-input.active'));
        }
      // qty_bundle_data(jQuery('.quantity-input.active'));

    }

    // setInterval(function() {
    //     if(jQuery('.topmadras').length == 1){
    //       var qty_select_div_text = jQuery('.product__block.product__block--variant_picker variant-selects select').val();
    //       if(qty_select_div_text == "160x200 cm"){
    //           jQuery('.product__inventory.main-pre .product__inventory-text').html('Vooruitbestelling.<span class="black-text">Wordt vanaf 17 juni verzonden.</span>');
    //       }else{
    //         jQuery('.product__inventory.main-pre .product__inventory-text').html('Vooruitbestelling.<span class="black-text">Wordt vanaf 15 juni verzonden.</span>');
    //       }
    //   }
    // },300);

  //   jQuery(document).on('click','.quantity-main .pro-option-qty li',function() {
  //     var pro_val_id = jQuery(this).attr('data-value-id');
  //     var pro_val_img = jQuery(this).attr('data-pro-img');
  //     var pro_val_text = jQuery(this).text();
  //     jQuery('.quantity-main .pro-option-qty li').removeClass('active');
  //     jQuery(this).addClass('active');
  //     jQuery(this).closest('.quantity-input').find('input').attr('data-product-id',pro_val_id);
  //     jQuery(this).closest('.quantity-input').find('.qty-bar-img img').attr('src',pro_val_img);
  //     jQuery('.quantity-main .pro-option-qty .active-option p span').text(pro_val_text);
  //     if(jQuery(this).closest('.quantity-input').hasClass('active')){
  //         jQuery( ".main-product product-form.product-form form input[name='id']" ).attr('value',pro_val_id);
  //     }
  // });

    function product_qty_btn() {
      var main_qty_price = jQuery('.quantity-main .quantity-input input:checked').next().find('.qty-bar-price').text();
      var main_qty_save_text = jQuery('.quantity-main .quantity-input input:checked').next().next().find('p').text();
  
      if(jQuery('.product-form__submit .price-info-btn').length == 1){
        jQuery('.product-form__submit .price-info-btn .pill_price').text(main_qty_price);
        if(main_qty_save_text != ""){
          jQuery('.product-form__submit .price-info-btn .saving-checkout').show().text(main_qty_save_text);
        }else{
          jQuery('.product-form__submit .price-info-btn .saving-checkout').hide().text(main_qty_save_text);
        }
      }
    }
    
    jQuery('.quantity-main .quantity-input input').on('click change',function() {
      product_qty_btn()
    })
    product_qty_btn();

  
    function variant_option_sticky_atc() {
      if(jQuery('.sticky-atc-bar .variant-option-product').length == 1){
        jQuery('.sticky-atc-bar__form').addClass('variant-bundles');
        var variant_option_html = jQuery('.sticky-atc-html').html();
        jQuery('.sticky-atc-bar .variant-option-product').html(variant_option_html);
    
        jQuery('.atc-bar-select-main').on('click', function() {
            jQuery(this).closest('.select-atc-bar').toggleClass('opened');
            jQuery(this).closest('.select-atc-bar').find('.atc-bar-content').fadeToggle('fast');
        });

        jQuery(document).on('click','.sticky-atc-bar .atc-bar-item',function(e){
          
          var get_html = jQuery(this).html();
          jQuery('.sticky-atc-bar .atc-bar-select-main').html(get_html);
          jQuery(this).closest('.select-atc-bar').toggleClass('opened');
          jQuery(this).closest('.select-atc-bar').find('.atc-bar-content').fadeToggle('fast');
          
          var product_quantity_check = jQuery(this).attr('data-val');
          var product_id_check = jQuery(this).attr('data-product-id');
          var qty_input_check = jQuery('.sticky-atc-bar  #product-form-sticky-atc-bar input[name="quantity"]');  
          var qty_input_id_check = jQuery('.sticky-atc-bar  #product-form-sticky-atc-bar input[name="id"]');  
            // console.log(product_quantity_check);
            if(qty_input_check.length == 0){
               jQuery( ".sticky-atc-bar  #product-form-sticky-atc-bar" ).prepend('<input type="hidden" name="quantity" value="'+product_quantity_check+'">');
            }else{
                qty_input_check.attr('value',product_quantity_check);
            }
            if(qty_input_id_check.length == 0){
               jQuery( ".sticky-atc-bar  #product-form-sticky-atc-bar" ).prepend('<input type="hidden" name="id" value="'+product_id_check+'" class="product-variant-id">');
            }else{
                qty_input_id_check.attr('value',product_id_check);
            }
          // jQuery( ".sticky-atc-bar  #product-form-sticky-atc-bar input[name='id']" ).attr('value',product_id_check);
        });    
      }
    }
    
    variant_option_sticky_atc();
  

    
    jQuery(".faq-tabs li").click(function () {
      var tab_id = jQuery(this).attr("data-tab");
      
      jQuery(".faq-tabs li").removeClass("active");
      jQuery(".faq-tab-content").removeClass("active");

      jQuery(this).addClass("active");
      jQuery("#" + tab_id).addClass("active");
    });

    jQuery(".faq-question").click(function () {
      jQuery(this).next(".faq-answer").slideToggle();
      jQuery(this).toggleClass("open");
    });

  // Product Page After ATC scrolling text
    if( jQuery('.marquee-info').length ){
      jQuery('.marquee-info').marquee({
          duration: 12000,
          gap: 10,
          delayBeforeStart: 0,
          direction: 'left',
          duplicateCount: 3,
          duplicated: true,
          startVisible: true    
      });
    };
  // Product Page After ATC scrolling text END

    // function pre_order_btn_text() {
    //   setTimeout(function(){
    //      var get_var_id = jQuery('.tyngdedyne-voksen .main-product .main-product-form input[name="id"]').val();
    //     console.log(get_var_id);
    //      if(get_var_id == '47403454562629'){
    //          jQuery('.tyngdedyne-voksen .main-product .main-product-form .product-form__submit').attr('style','--text-var:"Tilføj til kurv";');
    //      }else{
    //          jQuery('.tyngdedyne-voksen .main-product .main-product-form .product-form__submit').attr('style','--text-var:"FORUDBESTIL - D. 15 MARTS";');
    //      }
    //     },1800)
    // }

    // jQuery('body').on('click change','.tyngdedyne-voksen .main-product .product-form__input--button label',function() {
    //   pre_order_btn_text();
    // });
    // pre_order_btn_text();

  // Video Review ALL JS
    if( jQuery('.video_reviews .slider.videos').length ){ // video center mode reviews
        jQuery('.video_reviews .slider.videos').slick({
          mobileFirst: true,
          dots: false,
          infinite: false,
          loop: false,
          slidesToShow: 1,
          nextArrow: jQuery('.video_reviews .arrows .next'),
          prevArrow: jQuery('.video_reviews .arrows .prev'),
          responsive: [
            {
              breakpoint: 640,
              settings:{
                slidesToShow: 4,
                infinite: false,
                loop: false,
              }          
            }
          ]
        });
    
        jQuery('.video_reviews .slider.videos').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
          jQuery('.video_reviews .slider.videos button[data-state="pause"]').click();
      
          jQuery('.video_reviews .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
          jQuery('.video_reviews .progress .slider__label').text( calc + '% completed' );
        });
      
      jQuery('.video_reviews .video button[data-state="play"]').click(function(){
        var $this = jQuery(this).parent('div');
        var video = $this.find('video').get(0);
    
        video.play();
        jQuery(this).fadeOut();
        $this.find('button[data-state="pause"]').fadeIn();
    
      });
      jQuery('.video_reviews .video button[data-state="pause"]').click(function(){
        var $this = jQuery(this).parent('div');
        var video = $this.find('video').get(0);
    
        video.pause();
        jQuery(this).fadeOut();
        $this.find('button[data-state="play"]').fadeIn();
    
      });
    
      jQuery('.video_reviews .video').mouseenter(function(){
        var $this = jQuery(this);
        var video = $this.find('video').get(0);
        if( !video.paused ){
          jQuery(this).find('button[data-state="pause"]').fadeIn();
        }
      });
    
      jQuery('.video_reviews .video').mouseleave(function(){
        var $this = jQuery(this);
        var video = $this.find('video').get(0);
        if( !video.paused ){
          jQuery(this).find('button').fadeOut();
        } else{
          jQuery(this).find('button[data-state="play"]').fadeIn();
        }
      });
  }
    // Video Review ALL JS END

    // Product Loop Section
    if(jQuery('.custom-product-in').length > 0){
      jQuery('.variant-option-dropdown').on('change', function () {
        var selectedVariantId = jQuery(this).val();
        var $parentContainer = jQuery(this).closest('.quick-shop-form');
        var $hiddenInput = $parentContainer.find('.quick-show-custom-id');
    
        if ($hiddenInput.length) {
          $hiddenInput.val(selectedVariantId);
          $hiddenInput.prop('disabled', false);
        }

        var selectedprice = jQuery(this).find(':selected').attr('data-price');
        var selectedcompareprice = jQuery(this).find(':selected').attr('data-compareprice');
        var selectedsave = jQuery(this).find(':selected').attr('data-save');
        var mainPrice = jQuery(this).closest('.custom-product-block').find('.product-price');
        mainPrice.find('.main-info-price').text(selectedprice);
        mainPrice.find('.main-info-compareprice').text(selectedcompareprice);
        jQuery(this).closest('.custom-product-block').find('.total-saving .save-total').text(selectedsave);
        
        var selectedImage = jQuery(this).find(':selected').data('image');
        var mainImage = jQuery(this).closest('.custom-product-block').find('.pro-img-cut img');
        if (selectedImage) {
          console.log(selectedImage);
          mainImage.attr('src', selectedImage);
        }
        
      });
      jQuery('.custom-product-block').each(function () {
          const defaultImage = jQuery(this).find('#variant-select option:selected').data('image');
          const mainImage = jQuery(this).find('.pro-img-cut img');
          if (defaultImage) {
            mainImage.attr('src', defaultImage);
          }
        });
    
    }
   // Product Loop Section end

  if(jQuery('.sticky-atc-bar').length > 0){
    var windowsize = jQuery(window).width();
  // if (windowsize < 749) {
      jQuery('.sticky-atc-bar').removeClass('sticky-atc-bar--show');
      jQuery(window).on('scroll', function() {
        var scroll = jQuery(window).scrollTop(); 
        var add_to_btn_max = jQuery('body .main-product-form').offset().top - jQuery(window).height() + 100;
        var add_to_btn_min = jQuery('body .main-product-form').offset().top ;
        // scroll > add_to_btn_max &&
          if (scroll < add_to_btn_min) {
              jQuery('.sticky-atc-bar').removeClass('sticky-atc-bar--show');
          }else{
            jQuery('.sticky-atc-bar').addClass('sticky-atc-bar--show');
          }
      });
  };


  // if(jQuery('.mySwiper.clientslide').length > 0){
  //     var swiper = new Swiper(".mySwiper.clientslide", {
  //        loop: true,
  //         freeMode: true,
  //         spaceBetween: 10,
  //         grabCursor: true,
  //         slidesPerView: 5,
  //         loop: true,
  //         direction: "horizontal",
  //         autoplay: true,
  //         autoplay: {
  //           delay: 1,
  //           disableOnInteraction: false
  //         },
  //        breakpoints: {
  //         320: {
  //           slidesPerView: 2,
  //           spaceBetween: 5,
  //         },
  //         768: {
  //           slidesPerView: 4,
  //           spaceBetween: 10,
  //         },
  //         1024: {
  //           slidesPerView: 5,
  //           spaceBetween: 10,
  //         },
  //           1920: {
  //           slidesPerView: 5,
  //           spaceBetween: 10,
  //         },
  //       },
  //       freeMode: true,
  //       speed: 4000,
  //       freeModeMomentum: false
  //     });
  //   };

  if(jQuery('.client-review-slider').length > 0){
      new Swiper(".client-review-slider", {
            loop: true,
            allowTouchMove: true,
            grabCursor: true,
            speed: 5000,
            slidesPerView: "auto",
            spaceBetween: 12,

            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },

            freeMode: true,
            freeModeMomentum: false,

            breakpoints: {
                768: {
                  slidesPerView: "auto"
                }
            }
        });
    };
});



jQuery(document).ready(function() {


	jQuery('body').on("click",".product-quick-option .select-btn",function (e) {
		e.stopPropagation();

		const $thisMenu = jQuery(this).closest(".select-menu");
		jQuery(".select-menu").not($thisMenu).removeClass("active");
		$thisMenu.toggleClass("active");
	});

	// Click handler for option items
	jQuery('body').on("click",".product-card__wrapper:not('.qty-quick') .select-menu .options li", function () {

		const $thisMenu = jQuery(this).closest(".select-menu");
		const selectedText = jQuery(this).html();
        $thisMenu.find('.options li').removeClass("active");
		$thisMenu.find(".sBtn-text").html(selectedText);
		$thisMenu.removeClass("active").removeClass("red-new-btn");
        jQuery(this).addClass('active');

        const main_wrapper = jQuery(this).closest('.custom-product-wrapper');
        const product = JSON.parse(main_wrapper.attr('data-product-json'));
        const selectedOptions = {};
        var curr = jQuery(this);
        jQuery(curr).addClass('loading');
    
        main_wrapper.find('.select-menu li').each(function () {
          if(jQuery(this).hasClass('active')){
            const optionName = jQuery(this).closest('.select-menu').attr('data-option-name');
            const optionValue = jQuery(this).attr('data-option');
            selectedOptions[optionName] = optionValue;
          }
        });
        
        let matchedVariant = null;
        if (product.variants.length === 1 && product.options.length === 1 && product.options[0] === "Title") {
          // Type 1: No options
          matchedVariant = product.variants[0];
        } else {
          // Match variant with selected options
          matchedVariant = product.variants.find(variant => {
            return variant.options.every((val, idx) => {
              const optionName = product.options[idx];
              return selectedOptions[optionName] === val;
            });
          });
        }

        console.log(matchedVariant);
      
        var main_sale_price = FoxTheme.Currency.formatMoney(matchedVariant.price, FoxTheme.settings.moneyFormat);
        main_wrapper.find('.f-price__sale .f-price-item--sale').text(main_sale_price);
        main_wrapper.find('.f-price__regular .f-price-item--regular').text(main_sale_price);
      
        if(matchedVariant.compare_at_price != null){
          var main_compare_price = FoxTheme.Currency.formatMoney(matchedVariant.compare_at_price, FoxTheme.settings.moneyFormat);
          main_wrapper.find('.f-price__sale .f-price-item--regular s').text(main_compare_price);
        }else{
          main_wrapper.find('.f-price__sale .f-price-item--regular s').text('');
        }

        if(matchedVariant.featured_image != null){
           main_wrapper.find('.product-card__image-wrapper img').attr('src',matchedVariant.featured_image.src);
           main_wrapper.find('.product-card__image-wrapper img').attr('srcset',matchedVariant.featured_image.src);
        } 

	});

	// Click outside to close all dropdowns
	jQuery(document).on('click', '.product-quick-option' , function (e) {
		if (!jQuery(e.target).closest('.select-menu, .options').length) {
			jQuery('.select-menu').removeClass('active');
		}
	});



// Custom upsell Add to cart
  jQuery('body').on('click','#custom-add-to-cart', function () {
    const $wrapper = jQuery(this).closest('.custom-product-wrapper');
    const product = JSON.parse($wrapper.attr('data-product-json'));
    const selectedOptions = {};
    var curr = jQuery(this);
    jQuery(curr).addClass('loading');

    $wrapper.find('.select-menu li').each(function () {
      if(jQuery(this).hasClass('active')){
        const optionName = jQuery(this).closest('.select-menu').attr('data-option-name');
        const optionValue = jQuery(this).attr('data-option');
        selectedOptions[optionName] = optionValue;
      }
    });
    
    let matchedVariant = null;
    if (product.variants.length === 1 && product.options.length === 1 && product.options[0] === "Title") {
      // Type 1: No options
      matchedVariant = product.variants[0];
    } else {
      // Match variant with selected options
      matchedVariant = product.variants.find(variant => {
        return variant.options.every((val, idx) => {
          const optionName = product.options[idx];
          return selectedOptions[optionName] === val;
        });
      });
    }

    if (matchedVariant) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: matchedVariant.id
        },
        dataType: 'json',
        success: function () {
          jQuery(curr).removeClass('loading');
          // $wrapper.find('.message').text('Added to cart!');
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { open: true }
          }));
          jQuery('body').addClass('cart-show');
        },
        error: function () {
          jQuery(curr).removeClass('loading');
          $wrapper.find('.select-menu').addClass('red-new-btn');
          // $wrapper.find('.message').text('Error adding to cart.');
        }
      });
    } else {
      jQuery(curr).removeClass('loading');
      $wrapper.find('.select-menu').addClass('red-new-btn');
      // $wrapper.find('.message').text('Please select all required options.');
    }
  });

  function free_cart_gift() {
    const swiperEl = document.querySelector('.cart-drawer-gifts .swiper');
    if (swiperEl) {
      const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (slides.length >= 2) {
          new Swiper(swiperEl, {
            slidesPerView: 1.2,
            spaceBetween: 20,
          });
        }
    }
  }
  
  free_cart_gift();
  
  document.addEventListener('cart:updated', function(evt) {
    free_cart_gift()
  });

  setInterval(function() {
      if(jQuery('#CartDrawer').length && $('#CartDrawer')[0].hasAttribute('open') && $('#CartDrawer')[0].hasAttribute('active')){
          jQuery('body').addClass('cart-show');
      }else{
          jQuery('body').removeClass('cart-show');
      }
  },400);
  
});











// COPY CODE
jQuery(document).ready(function($){

  $(document).on("click",".copy-code",function(){

      var code = $(this).data("code");
      var el = $(this);

      function fallbackCopy(text){
          var temp = $("<input>");
          $("body").append(temp);
          temp.val(text).select();
          document.execCommand("copy");
          temp.remove();
      }

      if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).catch(function(){
              fallbackCopy(code);
          });
      }else{
          fallbackCopy(code);
      }

      el.addClass("copied show-tooltip");

      setTimeout(function(){
          el.removeClass("copied show-tooltip");
      },2000);

  });


    // TIMER FUNCTION
    function updateTimers(){

        $(".promo-banner").each(function(){

            var banner = $(this);
            var endDate = banner.data("end");
            var end = new Date(endDate).getTime();
            var now = new Date().getTime();
            var distance = end - now;

            if(distance <= 0){
                banner.hide();
                return;
            }

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if(days > 0){
              banner.find(".timer").text(
                  days + "d : " + hours + "t : " + minutes + "m : " + seconds + "s"
              );
            } else{
              banner.find(".timer").text(
                hours + "t : " + minutes + "m : " + seconds + "s"
            );
            }

        });

    }

    setInterval(updateTimers,1000);
    updateTimers();

});

jQuery(document).ready(function () {
  //  jQuery('button#customClose').on('click', function (e) {
  //   jQuery('.custom-fixed-bar').addClass('hidden');
  //  }); 

    jQuery('.section-bg-buttons .button-wrapper .button').on('click', function (e) {
        var targetHref = jQuery(this).attr('href');

        // Check if href is an internal section link like #section-one
        if (targetHref && targetHref.startsWith('#')) {
            e.preventDefault();

            var $targetSection = jQuery(targetHref);

            // If target section exists
            if ($targetSection.length) {
                // Get header height (for fixed header)
                var headerHeight = jQuery('header.header').outerHeight() || 0;

                // Calculate scroll position with header offset
                var targetPosition = $targetSection.offset().top - headerHeight - 20;

                // Smooth scroll
                jQuery('html, body').animate({
                    scrollTop: targetPosition
                }, 350);
            }
        }
        // else normal URL will work automatically
    });
});